import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {BasePage} from '@mintdata-wsp/wsp/ui/pages/BasePage';
import {SettingsPanel} from '@mintdata-wsp/wsp/ui/views/workspace/settings/SettingsPanel';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./SettingsPage.less');
const cx = classnames.bind(styles);

@observer
export class SettingsPage extends BasePage<RouteComponentProps<any>, any>
{
    render()
    {
        // const {match} = this.props;

        return (
            <Column className={cx(styles.page)}>

                <SettingsPanel {...this.props} />

            </Column>
        );
    }
}
